{
  "DeleteReminder": "미리 알림 삭제",
  "EditReminder": "미리 알림 편집",
  "RemindMe15Min": "15분 후 다시 알리기",
  "RemindMe5Min": "5분 후 다시 알리기",
  "RemindMe60Min": "1시간 후 다시 알리기",
  "RemindMeTomorrow": "내일 다시 알리기",
  "SetReminder": "{formattedReminderTime}에 설정된 미리 알림",
  "Snooze": "다시 알림"
}
